<template>
<div class="page">
  <div class="title">处罚决定书编号</div>
  <div class="tictet_num">{{ticket_num}}</div>
  <img class="icon_zanwu" src="https://s4s-images.oss-cn-shanghai.aliyuncs.com/alipay_vio/icon_chengshizanwu.png"/>
  <div class="txt1">该城市暂时不支持办理，敬请期待</div>
  <button type="primary" class="s4s-btn default-btn" @click="back">返回首页</button>
</div>
</template>

<script>
import advertisingShow from './../utils/advertising';
export default {
  name: 'donthandle',
  data() {
    return {
      ticket_num:'',
      advertisingShow: advertisingShow(),
    };
  },
  computed: {

  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '暂不支持办理'
      });
    }
    this.ticket_num = this.$route.query.noticeNum
  },
  methods: {
    back(){
      this.$router.push({
        path: '/ticket', 
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page{
  background: #fff;
  height: 100vh;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #9C9EA8;
}
.title{
  color: #333;
  margin-top: 20px;
  line-height: 22px;
}
.tictet_num{
  margin-top: 8px;
  line-height: 22px;
}
.icon_zanwu{
  height: 132px;
  width: 198px;
  margin-top: 88px;
  margin-bottom: 26px;
}
.txt1{
  font-size: 15px;
  margin-bottom: 80px;
}
.default-btn{
  width: 221px;
}
</style>

